import { render, staticRenderFns } from "./customer-search.component.vue?vue&type=template&id=131197d0&scoped=true&"
import script from "./customer-search.component.vue?vue&type=script&lang=ts&"
export * from "./customer-search.component.vue?vue&type=script&lang=ts&"
import style0 from "./customer-search.component.vue?vue&type=style&index=0&id=131197d0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131197d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCheckbox,VCol,VDivider,VRow})
